import React, { useState } from "react";
import "./entries.css";

function LoadReviewForm({ master, subproduct }) {
  const [tablaActiva, setTablaActiva] = useState(false);
  const [averia, setAveria] = useState(null);
  const [checkboxes, setCheckboxes] = useState({
    general: false,
    dangerous: false,
    perishable: false,
    live_animal: false,
    high_value: false,
    human_remains: false,
    diplomatic_bag: false,
    press: false,
    mail: false,
    comat_am: false,
    declared_value: false,
    pharma: false,
    ice: false,
    wet: false,
    big: false,
    heavy: false,
    fragile: false,
    refri: false,
    freezer: false,
    na: false,
  });

  const handleToggle = (e) => {
    const { name, checked } = e.target;
    setCheckboxes((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleCheckboxChange = (e) => {
    const empaquesTable = document.getElementById("tabla-empaques");
    const isAnyChecked =
      empaquesTable.querySelectorAll('input[type="checkbox"]:checked').length >
      0;
    setTablaActiva(isAnyChecked);
  };

  const handleSave = () => {
    /* if (validateForm()) {
            console.log("Formulario válido, enviando datos...");
            // Aquí iría la lógica para guardar los datos
        } else {
            console.log("Hay errores en el formulario.");
        } */
    alert("Guardar");
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-3">
            <p>
              <span className="fw-bold">Master:</span> {master.number}{" "}
            </p>
          </div>
          <div className="col-3">
            <p>
              <span className="fw-bold">Origen:</span> {master.origen}{" "}
            </p>
          </div>
          <div className="col-3">
            <p>
              <span className="fw-bold">Destino:</span> {master.destino}{" "}
            </p>
          </div>
          <div className="col-3">
            <p>
              <span className="fw-bold">Piezas Master:</span> {master.number}{" "}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-3">
            <p>
              <span className="fw-bold">Peso Master:</span> {master.number}{" "}
            </p>
          </div>
          <div className="col-3">
            <p>
              <span className="fw-bold">Volúmen Master:</span> {master.number}{" "}
            </p>
          </div>
          <div className="col-3">
            <p>
              <span className="fw-bold">Tipo de Mercancía:</span>{" "}
              {master.merchandiseType}{" "}
            </p>
          </div>
        </div>
        <p className="sub-title fw-bold mt-4" style={{ color: "#020C41" }}>
          Sección Recepción de Carga
        </p>
        <table className="table table-striped mt-4" id="tabla-empaques">
          <thead className="text-center">
            <tr>
              <th style={{ backgroundColor: "#020C41", color: "white" }}></th>
              <th style={{ backgroundColor: "#020C41", color: "white" }}></th>
              <th style={{ backgroundColor: "#020C41", color: "white" }}>
                EMPAQUE
              </th>
              <th style={{ backgroundColor: "#020C41", color: "white" }}></th>
            </tr>
          </thead>
          <tbody className="text-center">
            <tr>
              <td></td>
              <td>SKID (tarima)</td>
              <td>GRANEL (BX)</td>
              <td>MENSAJERÍA</td>
            </tr>
            <tr data-id="cardboard">
              <td>Cartón</td>
              <td>
                <input
                  type="checkbox"
                  name="cardboard-1"
                  onChange={handleCheckboxChange}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  name="cardboard-2"
                  onChange={handleCheckboxChange}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  name="cardboard-3"
                  onChange={handleCheckboxChange}
                />
              </td>
            </tr>
            <tr data-id="wood">
              <td>Madera</td>
              <td>
                <input
                  type="checkbox"
                  name="wood-1"
                  onChange={handleCheckboxChange}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  name="wood-2"
                  onChange={handleCheckboxChange}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  name="wood-3"
                  onChange={handleCheckboxChange}
                />
              </td>
            </tr>
            <tr data-id="plastic">
              <td>Plástico</td>
              <td>
                <input
                  type="checkbox"
                  name="plastic-1"
                  onChange={handleCheckboxChange}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  name="plastic-2"
                  onChange={handleCheckboxChange}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  name="plastic-3"
                  onChange={handleCheckboxChange}
                />
              </td>
            </tr>
            <tr data-id="metal">
              <td>Metal</td>
              <td>
                <input
                  type="checkbox"
                  name="metal-1"
                  onChange={handleCheckboxChange}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  name="metal-2"
                  onChange={handleCheckboxChange}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  name="metal-3"
                  onChange={handleCheckboxChange}
                />
              </td>
            </tr>
            <tr data-id="sack">
              <td>Costal</td>
              <td>
                <input
                  type="checkbox"
                  name="sack-1"
                  onChange={handleCheckboxChange}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  name="sack-2"
                  onChange={handleCheckboxChange}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  name="sack-3"
                  onChange={handleCheckboxChange}
                />
              </td>
            </tr>
            <tr data-id="bag">
              <td>Bolsa</td>
              <td>
                <input
                  type="checkbox"
                  name="bag-1"
                  onChange={handleCheckboxChange}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  name="bag-2"
                  onChange={handleCheckboxChange}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  name="bag-3"
                  onChange={handleCheckboxChange}
                />
              </td>
            </tr>
            <tr data-id="other">
              <td>Otros</td>
              <td>
                <input type="text" className="form-control" name="other-1" />
              </td>
              <td>
                <input type="text" className="form-control" name="other-2" />
              </td>
              <td>
                <input type="text" className="form-control" name="other-3" />
              </td>
            </tr>
            <tr data-id="can">
              <td>Bidones</td>
              <td>
                <input
                  type="checkbox"
                  name="can-1"
                  onChange={handleCheckboxChange}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  name="can-2"
                  onChange={handleCheckboxChange}
                />
              </td>
              <td data-id="can-checkboxes" className="d-flex">
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    name="can-31"
                    onChange={handleCheckboxChange}
                  />{" "}
                  Cartón
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    name="can-32"
                    onChange={handleCheckboxChange}
                  />{" "}
                  Metal
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    name="can-33"
                    onChange={handleCheckboxChange}
                  />{" "}
                  Plástico
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div className={tablaActiva ? "" : "disabled-overlay"}>
          <table className="table table-striped mt-4">
            <colgroup>
              <col style={{ width: "10%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "10%" }} />
            </colgroup>
            <thead className="text-center">
              <tr>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  NATURALEZA
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}></th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  Piezas
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  Peso
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  MANEJO
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  MANEJO
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  Piezas
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  Peso
                </th>
              </tr>
            </thead>
            <tbody className="text-center">
              <tr className="text-start">
                <td className="text-end">CGO</td>
                <td>
                  <input
                    type="checkbox"
                    name="general"
                    checked={checkboxes.general}
                    onChange={handleToggle}
                  />{" "}
                  GENERAL
                </td>
                <td>
                  {checkboxes.general && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {checkboxes.general && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td className="text-end">ICE</td>
                <td>
                  <input
                    type="checkbox"
                    name="ice"
                    checked={checkboxes.ice}
                    onChange={handleToggle}
                  />{" "}
                  HIELO-SECO
                </td>
                <td>
                  {checkboxes.ice && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {checkboxes.ice && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
              </tr>
              <tr className="text-start">
                <td className="text-end">DGR</td>
                <td>
                  <input
                    type="checkbox"
                    name="dangerous"
                    checked={checkboxes.dangerous}
                    onChange={handleToggle}
                  />{" "}
                  PELIGROSA
                </td>
                <td>
                  {checkboxes.dangerous && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {checkboxes.dangerous && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td className="text-end">WET</td>
                <td>
                  <input
                    type="checkbox"
                    name="wet"
                    checked={checkboxes.wet}
                    onChange={handleToggle}
                  />{" "}
                  HÚMEDA
                </td>
                <td>
                  {checkboxes.wet && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {checkboxes.wet && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
              </tr>
              <tr className="text-start">
                <td className="text-end">PER</td>
                <td>
                  <input
                    type="checkbox"
                    name="perishable"
                    checked={checkboxes.perishable}
                    onChange={handleToggle}
                  />{" "}
                  PERECEDERO
                </td>
                <td>
                  {checkboxes.perishable && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {checkboxes.perishable && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td className="text-end">BIG</td>
                <td>
                  <input
                    type="checkbox"
                    name="big"
                    checked={checkboxes.big}
                    onChange={handleToggle}
                  />{" "}
                  GRANDE
                </td>
                <td>
                  {checkboxes.big && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {checkboxes.big && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
              </tr>
              <tr className="text-start">
                <td className="text-end">AVI</td>
                <td>
                  <input
                    type="checkbox"
                    name="live_animal"
                    checked={checkboxes.live_animal}
                    onChange={handleToggle}
                  />{" "}
                  ANIMAL VIVO
                </td>
                <td>
                  {checkboxes.live_animal && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {checkboxes.live_animal && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td className="text-end">HEA</td>
                <td>
                  <input
                    type="checkbox"
                    name="heavy"
                    checked={checkboxes.heavy}
                    onChange={handleToggle}
                  />{" "}
                  HEAVY
                </td>
                <td>
                  {checkboxes.heavy && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {checkboxes.heavy && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
              </tr>
              <tr className="text-start">
                <td className="text-end">VAL</td>
                <td>
                  <input
                    type="checkbox"
                    name="high_value"
                    checked={checkboxes.high_value}
                    onChange={handleToggle}
                  />{" "}
                  ALTO VALOR
                </td>
                <td>
                  {checkboxes.high_value && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {checkboxes.high_value && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td className="text-end">HWC</td>
                <td>
                  <input
                    type="checkbox"
                    name="fragile"
                    checked={checkboxes.fragile}
                    onChange={handleToggle}
                  />{" "}
                  FRAGIL
                </td>
                <td>
                  {checkboxes.fragile && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {checkboxes.fragile && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
              </tr>
              <tr className="text-start">
                <td className="text-end">HUM</td>
                <td>
                  <input
                    type="checkbox"
                    name="human_remains"
                    checked={checkboxes.human_remains}
                    onChange={handleToggle}
                  />{" "}
                  RESTOS HUMANOS
                </td>
                <td>
                  {checkboxes.human_remains && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {checkboxes.human_remains && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td className="text-end">COL</td>
                <td>
                  <input
                    type="checkbox"
                    name="refri"
                    checked={checkboxes.refri}
                    onChange={handleToggle}
                  />{" "}
                  REFRI
                </td>
                <td>
                  {checkboxes.refri && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {checkboxes.refri && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
              </tr>
              <tr className="text-start">
                <td className="text-end">DIP</td>
                <td>
                  <input
                    type="checkbox"
                    name="diplomatic_bag"
                    checked={checkboxes.diplomatic_bag}
                    onChange={handleToggle}
                  />{" "}
                  VALIJA DIPLOMATICA
                </td>
                <td>
                  {checkboxes.diplomatic_bag && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {checkboxes.diplomatic_bag && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td className="text-end">FRO</td>
                <td>
                  <input
                    type="checkbox"
                    name="freezer"
                    checked={checkboxes.freezer}
                    onChange={handleToggle}
                  />{" "}
                  CONGELADOR
                </td>
                <td>
                  {checkboxes.freezer && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {checkboxes.freezer && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
              </tr>
              <tr className="text-start">
                <td className="text-end">NWP</td>
                <td>
                  <input
                    type="checkbox"
                    name="press"
                    checked={checkboxes.press}
                    onChange={handleToggle}
                  />{" "}
                  PRENSA
                </td>
                <td>
                  {checkboxes.press && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {checkboxes.press && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td className="text-end">N/A</td>
                <td>
                  <input
                    type="checkbox"
                    name="na"
                    checked={checkboxes.na}
                    onChange={handleToggle}
                  />{" "}
                  NO APLICA
                </td>
                <td>
                  {checkboxes.na && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {checkboxes.na && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
              </tr>
              <tr className="text-start">
                <td className="text-end">MAL</td>
                <td>
                  <input
                    type="checkbox"
                    name="mail"
                    checked={checkboxes.mail}
                    onChange={handleToggle}
                  />{" "}
                  MAIL
                </td>
                <td>
                  {checkboxes.mail && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {checkboxes.mail && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr className="text-start">
                <td className="text-end">COM</td>
                <td>
                  <input
                    type="checkbox"
                    name="comat_am"
                    checked={checkboxes.comat_am}
                    onChange={handleToggle}
                  />{" "}
                  COMAT AM
                </td>
                <td>
                  {checkboxes.comat_am && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {checkboxes.comat_am && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr className="text-start">
                <td className="text-end">VIC</td>
                <td>
                  <input
                    type="checkbox"
                    name="declared_value"
                    checked={checkboxes.declared_value}
                    onChange={handleToggle}
                  />{" "}
                  VALOR DECLARADO
                </td>
                <td>
                  {checkboxes.declared_value && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {checkboxes.declared_value && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr className="text-start">
                <td className="text-end">PIL</td>
                <td>
                  <input
                    type="checkbox"
                    name="pharma"
                    checked={checkboxes.pharma}
                    onChange={handleToggle}
                  />{" "}
                  PHARMA
                </td>
                <td>
                  {checkboxes.pharma && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {checkboxes.pharma && (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>

          <div className="row">
            <div className="col-4">
              <p
                className="sub-title fw-bold mt-4"
                style={{ color: "#020C41" }}
              >
                Avería
              </p>
              {/* Radios alineados en columnas */}
              <div className="row mb-1">
                <div className="col-6">
                  <label>
                    Sí{" "}
                    <input
                      type="radio"
                      name="failure"
                      value="si"
                      onChange={() => setAveria("si")}
                    />
                  </label>
                </div>
                <div className="col-6">
                  <label>
                    No{" "}
                    <input
                      type="radio"
                      name="failure"
                      value="no"
                      onChange={() => setAveria("no")}
                    />
                  </label>
                </div>
              </div>
              {averia === "si" && (
                <>
                  <div
                    className={`fade-slide ${averia === "si" ? "show" : ""}`}
                  >
                    <div className="mt-3">
                      <label className="fw-bold">Tipo:</label>
                      <textarea className="form-control" rows="3" />
                    </div>

                    <div className="mt-3">
                      <p
                        className="fw-bold mb-1"
                        style={{ fontSize: "0.9rem", marginTop: "1rem" }}
                      >
                        ¿Es calificada como Carga de Alto Riesgo? (HRCM)
                      </p>
                      <div className="row mt-2">
                        <div className="col-6">
                          <label>
                            Sí <input type="radio" name="hrcm" value="si" />
                          </label>
                        </div>
                        <div className="col-6">
                          <label>
                            No <input type="radio" name="hrcm" value="no" />
                          </label>
                        </div>
                      </div>
                      <p style={{ fontSize: "0.75rem", marginTop: "1rem" }}>
                        En caso de ser positivo, notificar al inspector de
                        seguridad.
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="col-4">
              <p
                className="sub-title fw-bold mt-4"
                style={{ color: "#020C41" }}
              >
                INSPECCIÓN
              </p>
              <div className="row mt-2">
                <div className="col-4">
                  <label>
                    Rayos X <input type="radio" name="inspection" />
                  </label>
                </div>
                <div className="col-4">
                  <label>
                    ETD <input type="radio" name="inspection" />
                  </label>
                </div>
                <div className="col-4">
                  <label>
                    Ambos <input type="radio" name="inspection" />
                  </label>
                </div>
              </div>
            </div>
            <div className="col-4 ms-auto">
              <p
                className="sub-title fw-bold mt-4"
                style={{ color: "#020C41" }}
              >
                TEMPERATURA
              </p>
              {/* <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <span className="fw-bold">*Requerida</span>
                            <select className="form-select" style={{ width: 'auto' }}>
                                <option value="">N/A</option>
                                <option value="FRO">FRO: -7°C a -2°C</option>
                                <option value="COL">COL: +2°C a +8°C</option>
                                <option value="ERT">ERT: +2°C a +25°C</option>
                                <option value="CRT">CRT: +15°C a +25°C</option>
                            </select>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <span className="fw-bold">Camión</span>
                            <input className="form-control" type="text" />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <span className="fw-bold">Anden</span>
                            <input className="form-control" type="text" />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <span className="fw-bold">Cooler</span>
                            <input className="form-control" type="text" />
                        </div> */}
              <div className="d-flex align-items-center mb-2">
                <label className="fw-bold me-2 mb-0" style={{ width: "90px" }}>
                  *Requerida
                </label>
                <select
                  className="form-select disabled-overlay"
                  style={{ width: "50%" }}
                >
                  <option value="">N/A</option>
                  <option value="FRO">FRO: -7°C a -2°C</option>
                  <option value="COL">COL: +2°C a +8°C</option>
                  <option value="ERT">ERT: +2°C a +25°C</option>
                  <option value="CRT">CRT: +15°C a +25°C</option>
                </select>
              </div>

              <div className="d-flex align-items-center mb-2">
                <label className="fw-bold me-2 mb-0" style={{ width: "90px" }}>
                  Camión
                </label>
                <input
                  className="form-control"
                  type="text"
                  style={{ width: "50%" }}
                />
              </div>

              <div className="d-flex align-items-center mb-2">
                <label className="fw-bold me-2 mb-0" style={{ width: "90px" }}>
                  Anden
                </label>
                <input
                  className="form-control"
                  type="text"
                  style={{ width: "50%" }}
                />
              </div>

              <div className="d-flex align-items-center">
                <label className="fw-bold me-2 mb-0" style={{ width: "90px" }}>
                  Cooler
                </label>
                <input
                  className="form-control"
                  type="text"
                  style={{ width: "50%" }}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col mt-4 d-flex justify-content-end">
              <button className="btnn" onClick={handleSave}>
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LoadReviewForm;
